(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const init = (root = document) => {
    if (reduced || !('IntersectionObserver' in window) || window.Shopify?.designMode) return;
    document.documentElement.classList.add('xj-motion');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {threshold: .06});
    root.querySelectorAll('.xj-reveal:not(.is-visible)').forEach((element) => observer.observe(element));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
